import { render, staticRenderFns } from "./SetBidQuantityWidget.vue?vue&type=template&id=52d5d8be&"
import script from "./SetBidQuantityWidget.vue?vue&type=script&lang=js&"
export * from "./SetBidQuantityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports